import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/index.md';
import Alerts from '../resources/alerts.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "profile"
    }}>{`Profile`}</h1>
    <Alerts query="platform=outdated-version&componentClass=InlineNestedAlert" mdxType="Alerts" />
    <p>{`You can use the Profile extension to store attributes about your user on the client. This information can be used later to target and personalize messages during online or offline scenarios, without having to connect to a server for optimal performance. The Profile extension manages the Client-Side Operation Profile (CSOP) and provides a way to react to APIs, updates user profile attributes, and shares the user profile attributes with the rest of the system as a generated event.`}</p>
    <p>{`The Profile data is used by other extensions to perform profile-related actions. An example is the Rules Engine extension that consumes the profile data and runs rules based on the profile data.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`The Profile extension does not require any configuration.`}</p>
    <p>{`To get started with the Profile extension:`}</p>
    <ol>
      <li parentName="ol">{`Configure the Profile Extension in the Data Collection UI.`}</li>
      <li parentName="ol">{`Add the Profile extension to your app.`}</li>
      <li parentName="ol">{`Implement Profile APIs to:`}
        <ul parentName="li">
          <li parentName="ul">{`Update user attributes.`}</li>
          <li parentName="ul">{`Remove user attributes.`}</li>
        </ul>
      </li>
    </ol>
    <h2 {...{
      "id": "install-the-profile-extension-in-the-data-collection-ui"
    }}>{`Install the Profile extension in the Data Collection UI`}</h2>
    <ol>
      <li parentName="ol">{`In the Data Collection UI, in your mobile property, select the `}<strong parentName="li">{`Extensions`}</strong>{` tab.`}</li>
      <li parentName="ol">{`On the `}<strong parentName="li">{`Catalog`}</strong>{` tab, locate or search for the `}<strong parentName="li">{`Profile`}</strong>{` extension, and select `}<strong parentName="li">{`Install`}</strong>{`.`}</li>
      <li parentName="ol">{`There are no configuration settings for `}<strong parentName="li">{`Profile`}</strong>{`.`}</li>
      <li parentName="ol">{`Select `}<strong parentName="li">{`Save`}</strong>{`.`}</li>
      <li parentName="ol">{`Follow the publishing process to update SDK configuration.`}</li>
    </ol>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1280px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "45.62500000000001%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/5530d/configuration.webp 320w", "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/0c8fb/configuration.webp 640w", "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/94b1e/configuration.webp 1280w", "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/ff8b5/configuration.webp 1494w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/dd4a7/configuration.png 320w", "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/0f09e/configuration.png 640w", "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/bbbf7/configuration.png 1280w", "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/60b6f/configuration.png 1494w"],
            "sizes": "(max-width: 1280px) 100vw, 1280px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/client-sdks/previous-versions/static/49b0637eaf534688564dcae0ae808f4b/bbbf7/configuration.png",
            "alt": "AEP Profile extension configuration",
            "title": "AEP Profile extension configuration",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "add-the-profile-extension-to-your-app"
    }}>{`Add the Profile extension to your app`}</h2>
    <p>{`To add the Profile extension to your app:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="5" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=add" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=add" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&task=add" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&task=add" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&task=add" mdxType="Tabs" />
    <h2 {...{
      "id": "register-the-extension"
    }}>{`Register the extension`}</h2>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="7" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=register" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=register" mdxType="Tabs" />
    <p>{`React Native`}</p>
    <Tabs query="platform=react-native&task=register" mdxType="Tabs" />
    <p>{`Flutter`}</p>
    <Tabs query="platform=flutter&task=register" mdxType="Tabs" />
    <p>{`Cordova`}</p>
    <Tabs query="platform=cordova&task=register" mdxType="Tabs" />
    <p>{`Unity`}</p>
    <Tabs query="platform=unity&task=register" mdxType="Tabs" />
    <p>{`Xamarin`}</p>
    <Tabs query="platform=xamarin&task=register" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      